/* eslint-disable quote-props */

// Compiled from: https://github.com/PagerDuty/web/blob/main/app/models/phone_code.rb#L246
// Canada, USA, EMEA & AJP Country Codes
const USA_EMEA_AJP_CODES = {
  '48': 'Poland',
  '49': 'Germany',
  '33': 'France',
  '45': 'Denmark',
  '7': 'Russia',
  '44': 'United Kingdom',
  '31': 'Netherlands',
  '41': 'Switzerland',
  '353': 'Ireland',
  '34': 'Spain',
  '39': 'Italy',
  '420': 'Czech Republic',
  '352': 'Luxembourg',
  '46': 'Sweden',
  '43': 'Austria',
  '351': 'Portugal',
  '972': 'Israel',
  '971': 'United Arab Emirates',
  '27': 'South Africa',
  '81': 'Japan',
  '64': 'New Zealand',
  '61': 'Australia',
  '886': 'Taiwan',
  '1': 'Canada and United States of America'
};

const isSmsAllowedDuringTrial = countryPhoneCode => !!USA_EMEA_AJP_CODES[countryPhoneCode];

export default isSmsAllowedDuringTrial;
